import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ApiErrorBannerProps {
  message?: string;
}

const ApiErrorBanner: React.FC<ApiErrorBannerProps> = ({ message }) => (
  <div className="bg-[#333] border border-[#ff6b6b]/30 text-[#ccc] rounded-lg p-4 mb-6 flex items-center space-x-3">
    <AlertCircle className="w-6 h-6 text-[#ff6b6b]" />
    <div>
      <strong className="text-white">Server Error:</strong> {message || 'The server is currently experiencing technical issues. Please try again later.'}
    </div>
  </div>
);

export default ApiErrorBanner; 